import actions from "../../components/header/headerActions/actions";
import { initialState } from "./../initialState";
import * as BillingActions from "./billingActions";

export const billingReducer = (state = initialState.billing, action) => {
    switch (action.type) {
        case BillingActions.REQUEST_BILLING_ACTIVITIES:
            return Object.assign({}, state, {
                billingActivitiesRequest: action.billingActivitiesRequest,
            });

        case BillingActions.REQUEST_BILLING_ACTIVITIES_SUCCEEDED:
            return Object.assign({}, state, {
                activities: action.activities,
            });

        case BillingActions.REQUEST_BILLING_ACTIVITIES_FAILED:
            return initialState.billing.activities;

        case BillingActions.SAVE_BILLING_SKU_INFO:
            return Object.assign({}, state, {
                billingSKUInfoRequest: action.billingSKUInfoRequest,
            });

        case BillingActions.SAVE_BILLING_SKU_INFO_SUCCEEDED:
            return Object.assign({}, state, {
                billingSKUInfoResponse: action.billingSKUInfoResponse,
            });
        case BillingActions.SAVE_BILLING_SKU_INFO_FAILED:
            return initialState.billing.billingSKUInfoResponse;

        case BillingActions.SAVE_LOCATE_INFO:
            return Object.assign({}, state, {
                locateInfoRequest: action.relatedWorkRequest,
            });

        case BillingActions.SAVE_RELATED_WORK_INFO_SUCCESS:
            return Object.assign({}, state, {
                locateInfoResponse: action.message,
            });

        case BillingActions.REQUEST_BILLING_COMMENTS_SUCCESS:
            return { ...state, comments: action.comments };

        case BillingActions.REQUEST_BILLING_ACTIVITIES_FAILED:
            return { ...state, comments: [] };
        case BillingActions.CLEAR_COMMENTS:
            return { ...state, comments: initialState.billing.comments };
        default:
            return state;
    }
};
